import type { HudState } from "../game/Game";
import type { TouchMode } from "../game/settings";

/**
 * Whether the on-screen stick and buttons are up (#67): once past the start
 * screen, while there's skating to do (not in the demo, a menu, a run's
 * results, a challenge's card or a hub's list, #86). The Touch controls setting decides the
 * rest: Auto on a touch device (`touch`: touch-only, or a finger has landed
 * on the park) until a controller's connected, On always, Off never.
 */
export function showTouchControls(
  hud: Pick<HudState, "demo" | "paused" | "padName" | "run" | "challenge" | "hub">,
  touch: boolean,
  started: boolean,
  mode: TouchMode = "auto",
): boolean {
  if (mode === "off" || (mode === "auto" && (!touch || hud.padName))) return false;
  return (
    started &&
    !hud.demo &&
    !hud.paused &&
    !hud.hub &&
    hud.run?.phase !== "done" &&
    !(hud.challenge && hud.challenge.phase !== "running" && hud.challenge.phase !== "overtime")
  );
}
